import Navigation from "../navigation/navigation.component";
import Button from "../button/button.component";
import { HeroStyled, HeroContentStyled, HeroMinimalist, HeroContentminimalist } from "./hero.styles";

export const HeroType = {
    defaultHero: 'default',
    DetailPage: 'detailPage',
    Minimalist: 'minimalist',
}
const Hero = ({backgroundImage, headerPrimary, headerSecondary, heroType = HeroType.defaultHero, noNavigation=false}) => {
    return (
        <>
        {
            heroType === HeroType.Minimalist ?
            <HeroMinimalist>
                <Navigation />
                <HeroContentminimalist>
                    <h1 className="header__primary">
                        <span className="header__primary--main">
                            {headerPrimary}
                        </span>
                    </h1>
                </HeroContentminimalist>
            </HeroMinimalist> :
            <HeroStyled image = {backgroundImage} heroType = {heroType}>
                {!noNavigation && <Navigation />}
                <HeroContentStyled heroType = {heroType}>
                    <div className="hero__content-container">
                        <h1 className={heroType === HeroType.defaultHero ? "header__primary u-margin-bottom-medium" : "header__primary"}> 
                            <span className="header__primary--main header__primary--main-animated">
                                {headerPrimary}
                            </span>
                            <span className="header__primary--sub header__primary--sub-animated">
                                {headerSecondary}
                            </span>
                        </h1> 
                        {heroType === HeroType.defaultHero ? <Button className="btn" link="/events" buttonclassName="btn--animated"> Explore with mamba hikers </Button> : null}
                    </div>
                </HeroContentStyled>
            </HeroStyled>
        }
        </>
    )
}

export default Hero;